export default __webpack_public_path__ + "4ca637205f423fa32a8445727a1e5fdd.png";